import ClientComplexTable from "./components/ClientComplexTable";
// import { useNavigate } from "react-router-dom";
// import { IoArrowBack } from "react-icons/io5";
// import AutoCallingToggle from "components/toggle/AutoCallingToggle";
import { useCallback, useEffect, useState } from "react";
import { getClientListing } from "./mvc/clientController";

const ClientTables = () => {
  // const navigate = useNavigate();
  // const [autoCallingEnabled, setAutoCallingEnabled] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({
    search: "",
    country: "",
    state: "",
    district: "",
    priority: "",
    sort: "latest_updated",
    folderId: "",
  });

  // const handleBack = () => {
  //   navigate("/admin/client-management");
  // };

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
  };

  const fetchClients = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const { clients, total: totalCount } = await getClientListing({
        page,
        limit,
        priority: filters.priority,
        search: filters.search,
        sort: filters.sort,
        folderId: filters.folderId,
      });

      setTableData(clients);
      setTotal(totalCount);
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "Failed to fetch clients");
      setTableData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, limit, filters.priority, filters.search, filters.sort, filters.folderId]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  const handleFilterChange = useCallback((key, value) => {
    setPage(1);
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleFiltersChange = useCallback((nextFilters) => {
    setPage(1);
    setFilters(nextFilters);
  }, []);

  const handleClearFilters = useCallback(() => {
    setPage(1);
    setFilters({
      search: "",
      country: "",
      state: "",
      district: "",
      priority: "",
      sort: "latest_updated",
      folderId: "",
    });
  }, []);

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ show: false, message: "", type: "" });
      }, 3000);
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [toast.show]);

  return (
    <div>
      {toast.show && (
        <div
          className={`fixed right-6 top-20 z-[60] rounded-lg px-4 py-3 text-sm font-semibold shadow-md backdrop-blur-sm ${
            toast.type === "error"
              ? "border border-red-400/70 bg-red-500/20 text-red-700"
              : "border border-green-400/70 bg-green-500/20 text-green-700"
          }`}
        >
          {toast.message}
        </div>
      )}

      <div className="flex items-center justify-between mb-4 mt-6">
        <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Client Management</h2>
      </div>

      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <ClientComplexTable
          tableData={tableData}
          showToast={showToast}
          isLoading={loading}
          error={error}
          filters={filters}
          total={total}
          onFilterChange={handleFilterChange}
          onFiltersChange={handleFiltersChange}
          onClearFilters={handleClearFilters}
          currentPage={page}
          pageSize={limit}
          totalPages={Math.max(1, Math.ceil(total / limit))}
          onPageChange={setPage}
          onPageSizeChange={(nextLimit) => {
            setLimit(nextLimit);
            setPage(1);
          }}
          onRefresh={fetchClients}
        />
      </div>
    </div>
  );
};

export default ClientTables;
